import RIOTable, { TableBody, TableColumn, TableRow } from '@rio-cloud/rio-uikit/Table';
import classnames from 'classnames';
import ContentLoader from 'components/content/ContentLoader';

import DataTableHeader from './DataTableHeader';
import type { TableColumn as DataTableColumn, TableActionColumnConfig } from './types';

interface TableSkeletonProps<T extends object> {
    testId: string;
    columns: readonly DataTableColumn<T>[];
    actionColumn?: TableActionColumnConfig<T>;
    rows?: number;
}

const TableSkeleton = <T extends object>({ testId, columns, actionColumn, rows = 3 }: TableSkeletonProps<T>) => (
    <div className='width-100pct display-flex flex-column' data-testid={testId}>
        <RIOTable
            className='width-100pct border-color-light'
            rowKey='id'
            border={false}
            rounded={false}
            rowSeparatorWidth={0}
        >
            <DataTableHeader columns={columns} actionColumn={actionColumn} />
            <TableBody>
                {Array.from({ length: rows }, (_, rowIndex) => (
                    <TableRow key={rowIndex} id={rowIndex}>
                        {columns.map(column => (
                            <TableColumn
                                key={String(column.key)}
                                columnKey={String(column.key)}
                                className={classnames(
                                    'text-size-14 line-height-14 padding-x-15 text-color-darkest',
                                    column.className
                                )}
                                horizontalAlign={column.align}
                                value={<ContentLoader height='16px' width='80%' />}
                            />
                        ))}
                        {actionColumn && <TableColumn columnKey='actions' horizontalAlign='right' />}
                    </TableRow>
                ))}
            </TableBody>
        </RIOTable>
    </div>
);

export default TableSkeleton;
